import { render, staticRenderFns } from "./GoogleAnalytics4.vue?vue&type=template&id=27c9aa14"
import script from "./GoogleAnalytics4.vue?vue&type=script&lang=js"
export * from "./GoogleAnalytics4.vue?vue&type=script&lang=js"
import style0 from "./GoogleAnalytics4.vue?vue&type=style&index=0&id=27c9aa14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports